export const FETCH_NOTIFICATION_SOURCES = 'spaces/notificationsources/FETCH'
export const FETCH_NOTIFICATION_SOURCES_SUCCESS = `${FETCH_NOTIFICATION_SOURCES}_SUCCESS`

export const CREATE_NOTIFICATION_SOURCE = 'spaces/notificationsources/CREATE'
export const CREATE_NOTIFICATION_SOURCE_SUCCESS = `${CREATE_NOTIFICATION_SOURCE}_SUCCESS`

export const DELETE_NOTIFICATION_SOURCE = 'spaces/notificationsources/DELETE'
export const DELETE_NOTIFICATION_SOURCE_SUCCESS = `${DELETE_NOTIFICATION_SOURCE}_SUCCESS`

export const UPDATE_NOTIFICATION_SOURCE = 'spaces/notificationsources/UPDATE'
export const UPDATE_NOTIFICATION_SOURCE_SUCCESS = `${UPDATE_NOTIFICATION_SOURCE}_SUCCESS`
